import type { ReactNode } from 'react';

export const symbol_android_wifi_3_bar: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M479.76-688q-87.39 0-170.32 27.5Q226.52-633 157-581q-19 14-42 13.5t-39.97-17.99Q59-602 60-624.5 61-647 79-661q85.82-67.08 188.7-102.54Q370.58-799 479.8-799q110.2 0 212.73 35.46Q795.07-728.08 881-661q18 14 19 36.5t-15.03 39.01Q868-568 845-567.5T803-581q-70-52-152.43-79.5T479.76-688Zm.24 244q-42 0-80.5 11T326-402q-19 11-40.5 9.5t-36.32-16.71Q235-423.58 235.5-444.29T253-476q51-34 108.37-52 57.37-18 118.5-18t118.63 18Q656-510 707-476q17 11 17.5 31.71t-13.68 35.08Q696-394 674.5-392.5T634-402q-35-20-73.5-31T480-444Zm-49.5 262.41q-20.5-20.59-20.5-49.5t20.59-49.41q20.59-20.5 49.5-20.5t49.41 20.59q20.5 20.59 20.5 49.5t-20.59 49.41q-20.59 20.5-49.5 20.5t-49.41-20.59Z"
		/>
	</svg>
);
